import { CircleHelp } from "lucide-react";
import { useId } from "react";
import type { MetricProps } from "../types/layout.js";
import { Card } from "./Card.js";
import { IconTile } from "./IconTile.js";

export function Metric({ label, value, description, icon, tooltip }: MetricProps) {
  const tooltipId = useId();
  return (
    <div className="flex items-start gap-4">
      {icon ? <IconTile>{icon}</IconTile> : null}
      <div className="min-w-0">
        <div className="flex items-center gap-1.5">
          <p className="min-w-0 text-sm text-muted-foreground">{label}</p>
          {tooltip ? (
            <span className="group/tip relative">
              <button
                aria-describedby={tooltipId}
                className="grid size-5 place-items-center rounded-full text-muted-foreground focus-visible:outline-none focus-visible:ring-3 focus-visible:ring-ring/25"
                data-control-id={tooltip.controlId}
                type="button"
              >
                <CircleHelp aria-hidden="true" className="size-3.5" />
                <span className="sr-only">{tooltip.label}</span>
              </button>
              <span
                className="pointer-events-none absolute bottom-full left-0 z-10 mb-2 w-56 rounded-xl border border-border/60 bg-background px-3 py-2 text-xs leading-relaxed text-foreground opacity-0 shadow-md transition-opacity group-hover/tip:opacity-100 group-focus-within/tip:opacity-100"
                id={tooltipId}
                role="tooltip"
              >
                {tooltip.text}
              </span>
            </span>
          ) : null}
        </div>
        <p className="mt-2 text-3xl font-medium tracking-tight tabular-nums">{value}</p>
        {description ? (
          <p className="mt-2 text-xs leading-relaxed text-muted-foreground">{description}</p>
        ) : null}
      </div>
    </div>
  );
}
export function MetricCard(props: MetricProps) {
  return (
    <Card>
      <Metric {...props} />
    </Card>
  );
}
